module.exports = __webpack_public_path__ + "static/house_coin.df4de4c2.svg";